"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaybackSpeed = void 0;

var icons_1 = require("@ant-design/icons");

var WebSettingsContext_1 = require("@thesisedu/web/dist/WebSettingsContext");

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var MediaPlaybackContext_1 = require("../MediaPlaybackContext");

var styled_1 = require("../styled");

var DEFAULT_SPEEDS = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];

function PlaybackSpeed(_ref) {
  var compact = _ref.compact;

  var _ref2 = (0, WebSettingsContext_1.useWebSettings)(),
      _ref2$playbackSpeeds = _ref2.playbackSpeeds,
      playbackSpeeds = _ref2$playbackSpeeds === void 0 ? DEFAULT_SPEEDS : _ref2$playbackSpeeds;

  var _ref3 = (0, MediaPlaybackContext_1.useMediaPlaybackContext)(),
      playbackSpeed = _ref3.playbackSpeed,
      setPlaybackSpeed = _ref3.setPlaybackSpeed;

  return react_1.default.createElement(antd_1.Dropdown, {
    trigger: ['click'],
    placement: 'topCenter',
    overlay: react_1.default.createElement(antd_1.Menu, {
      selectedKeys: [playbackSpeed.toString()],
      onClick: function onClick(_ref4) {
        var key = _ref4.key;
        return setPlaybackSpeed(parseFloat(key.toString()));
      }
    }, playbackSpeeds.map(function (speed) {
      return react_1.default.createElement(antd_1.Menu.Item, {
        key: speed.toString()
      }, speed.toString(), "x");
    }))
  }, react_1.default.createElement(antd_1.Tooltip, {
    title: 'Playback Speed',
    mouseEnterDelay: 1
  }, react_1.default.createElement(styled_1.ControlContainer, {
    compact: compact !== undefined
  }, react_1.default.createElement(icons_1.DashboardOutlined, null))));
}

exports.PlaybackSpeed = PlaybackSpeed;